import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { routing } from "@/i18n/routing";
import { SITE_URL } from "@/lib/site";

/**
 * Adds hreflang alternates for locale-prefixed routes (e.g. /en/about → /de/about).
 */
export default function SeoHreflang() {
  const { pathname } = useLocation();
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return null;

  const first = segments[0];
  if (!routing.locales.includes(first)) return null;

  const rest = segments.slice(1);
  const pathAfterLocale = rest.length ? `/${rest.join("/")}` : "";

  const alternates = routing.locales.map((loc) => ({
    lang: loc,
    href: `${SITE_URL}/${loc}${pathAfterLocale}`,
  }));

  const xDefaultHref = `${SITE_URL}/${routing.defaultLocale}${pathAfterLocale}`;

  return (
    <Helmet>
      {alternates.map(({ lang, href }) => (
        <link key={lang} rel="alternate" hrefLang={lang} href={href} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={xDefaultHref} />
    </Helmet>
  );
}
